import React from 'react';
import { useToggle } from 'react-use';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import DarkLogo from '@assets/img/dark-logo.svg';
import LightLogo from '@assets/img/light-logo.svg';
import { Path } from '../../routes';

const Logo = {
  light: LightLogo,
  dark: DarkLogo,
};

function Brand({
  className,
  theme,
  isOpen,
  toggle,
  withoutHamburger,
  onClick,
}) {
  const Component = Logo[theme];

  return (
    <div className={cn('brand', className)}>
      <NavLink to={Path.DOCS} onClick={onClick}>
        <Component width={113} height={28} alt="PING42" />
      </NavLink>
      {!withoutHamburger && (
        <button
          onClick={toggle}
          className={cn('hamburger hamburger--elastic', {
            'is-active': isOpen,
          })}
          type="button"
          aria-label="Menu"
          aria-controls="navigation"
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>
      )}
    </div>
  );
}

Brand.propTypes = {
  theme: PropTypes.string,
};

Brand.defaultProps = {
  theme: 'light',
};

export default Brand;
